import { Form, DatePicker, Radio, TimePicker, Checkbox, Select } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { useTranslation } from "react-i18next";

interface PeriodicitySectionProps {
  isRecurrent: boolean;
  repeatEvery: string | null;
  selectedTime: Dayjs | null;
  form: any;
}

export const PeriodicitySection: React.FC<PeriodicitySectionProps> = ({
  isRecurrent,
  repeatEvery,
  selectedTime,
  form,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      <h3 className="text-base font-semibold mb-2">
        {t("taskHub.modal.periodicity") || ""}
      </h3>
      <div className="grid grid-cols-2 gap-x-4">
        <Form.Item name="is_recurrent" valuePropName="checked">
          <Checkbox>{t("taskHub.modal.enableRecurrence") || ""}</Checkbox>
        </Form.Item>

        <Form.Item name="priority" label={t("taskHub.modal.priority") || ""}>
          <Select placeholder={t("taskHub.modal.selectPriority") || ""}>
            <Select.Option value={1}>1</Select.Option>
            <Select.Option value={2}>2</Select.Option>
            <Select.Option value={3}>3</Select.Option>
            <Select.Option value={4}>4</Select.Option>
            <Select.Option value={5}>5</Select.Option>
          </Select>
        </Form.Item>
      </div>

      <div className="grid grid-cols-2 gap-x-4">
        <Form.Item
          name="start_periodicity"
          label={t("taskHub.modal.startDate") || ""}
        >
          <DatePicker
            format="YYYY-MM-DD HH:mm"
            showTime
            style={{ width: "100%" }}
            disabledDate={(date) => date && date.isBefore(dayjs(), "day")}
          />
        </Form.Item>

        {isRecurrent && (
          <>
            <Form.Item
              name="end_periodicity"
              label={t("taskHub.modal.endDate") || ""}
            >
              <DatePicker
                format="YYYY-MM-DD HH:mm"
                showTime
                style={{ width: "100%" }}
                disabledDate={(current) => {
                  const start = form.getFieldValue("start_periodicity");
                  if (!start || !current) return false;
                  return current.isBefore(dayjs(start), "day");
                }}
              />
            </Form.Item>

            <Form.Item
              name="periodicity"
              label={t("taskHub.modal.repeatEvery") || ""}
            >
              <Radio.Group className="flex flex-col">
                <Radio value="daily">{t("taskHub.modal.daily") || ""}</Radio>
                <Radio value="weekly">{t("taskHub.modal.weekly") || ""}</Radio>
                <Radio value="monthly">
                  {t("taskHub.modal.monthly") || ""}
                </Radio>
                <Radio value="yearly">{t("taskHub.modal.yearly") || ""}</Radio>
              </Radio.Group>
            </Form.Item>
          </>
        )}

        {repeatEvery && (
          <Form.Item name="time" label={t("taskHub.modal.time") || ""}>
            <TimePicker
              format="HH:mm"
              style={{ width: "100%" }}
              value={selectedTime}
            />
          </Form.Item>
        )}
      </div>
    </div>
  );
};
